import api from './client';
import type { AxiosResponse } from './client';
import type { Part, PartUploadResponse, PartStats } from './types/parts';

export const partsAPI = {
  list: (params?: Record<string, any>): Promise<AxiosResponse<{ count: number; results: Part[] }>> =>
    api.get('/purchasing/parts/', { params }),

  get: (id: number): Promise<AxiosResponse<Part>> =>
    api.get(`/purchasing/parts/${id}/`),

  create: (data: Partial<Part>): Promise<AxiosResponse<Part>> =>
    api.post('/purchasing/parts/', data),

  update: (id: number, data: Partial<Part>): Promise<AxiosResponse<Part>> =>
    api.patch(`/purchasing/parts/${id}/`, data),

  delete: (id: number): Promise<AxiosResponse<void>> =>
    api.delete(`/purchasing/parts/${id}/`),

  stats: (params?: Record<string, any>): Promise<AxiosResponse<PartStats>> =>
    api.get('/purchasing/parts/stats/', { params }),

  upload: (file: File, supplierId?: number): Promise<AxiosResponse<PartUploadResponse>> => {
    const formData = new FormData();
    formData.append('file', file);
    if (supplierId) {
      formData.append('supplier_id', String(supplierId));
    }
    return api.post('/purchasing/parts/upload/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
